"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationBaseSchema = exports.ProvinceSchema = exports.DistrictSchema = exports.LocationRegionSchema = void 0;
/* eslint-disable perfectionist/sort-objects */
const zod_1 = require("zod");
const shared_1 = require("../shared");
exports.LocationRegionSchema = zod_1.z.enum([
    'NORTH',
    'NORTH_EAST',
    'CENTRAL',
    'EAST',
    'WEST',
    'SOUTH',
]);
exports.DistrictSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    code: zod_1.z.number(),
    localized: shared_1.LocalizedFieldSchema,
    postalCode: zod_1.z.string(),
    provinceCode: zod_1.z.number(),
});
exports.ProvinceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    code: zod_1.z.number(),
    localized: shared_1.LocalizedFieldSchema,
    region: exports.LocationRegionSchema,
});
exports.LocationBaseSchema = zod_1.z.object({
    districtId: shared_1.UUIDSchema.nullable(),
    provinceId: shared_1.UUIDSchema.nullable(),
    address: zod_1.z.string().nullable(),
    district: shared_1.LocalizedFieldSchema,
    province: shared_1.LocalizedFieldSchema,
    region: exports.LocationRegionSchema,
    postalCode: zod_1.z.string(),
});
